import * as React from 'react';

import { AutoGeolocationModal } from 'components/geolocation-modal';
import { ModalConfirmRestaurant } from 'components/modal-confirm-restaurant';
import { useAutoSelectRestaurant } from 'hooks/use-auto-select-restaurant';

const AutoSelectRestaurant = () => {
  // The useAutoSelectRestaurant hook is housed here so we can conditionally call it with an LD flag at parent level
  const { confirmRestaurant, restaurantToConfirm } = useAutoSelectRestaurant();

  return restaurantToConfirm ? (
    <ModalConfirmRestaurant
      restaurant={restaurantToConfirm}
      confirmRestaurant={confirmRestaurant}
    />
  ) : (
    <AutoGeolocationModal />
  );
};

export default AutoSelectRestaurant;
